<template>
    <div class="container">
        <content-header title="История поликлиники"/>
        <p style="text-indent: 20px">История поликлиники Управления делами Президента Российской Федерации начинается с
            момента выхода распоряжения Исполнительного комитета Московского городского Совета депутатов трудящихся от
            14 мая 1976 года «Об отводе Управлению делами Совета Министров СССР земельного участка по вл. №14,
            ул.Плющиха, под строительство здания поликлиники».</p>
        <p style="text-indent: 20px">Необходимость строительства поликлиники была обусловлена тем, что работники
            организаций, подведомственных Хозяйственному управлению Управления делами Совета Министров СССР, не были
            закреплены за медицинским учреждением, где бы им оказывалась своевременная медицинская помощь и в
            соответствии с предъявляемыми требованиями проводились предварительные, периодические и целевые осмотры,
            профилактические прививки, диспансерное наблюдение и т.д. Проектирование поликлиники было поручено
            Проектному институту Министерства здравоохранения Российской Федерации.</p>
        <div class="flex">
            <img src="../../assets/images/staticPages/history1.jpg" alt="history1" height="305" width="305"
                 class="right-5px"/>
            <img src="../../assets/images/staticPages/history3.jpg" alt="history3" height="305" width="305"
                 class="right-5px"/>
            <img src="../../assets/images/staticPages/history2.jpg" alt="history2" height="305" width="305"/>
        </div>
        <p style="text-indent: 20px">1 марта 1984 года поликлиника начала функционировать как лечебно-профилактическое
            учреждение. По уровню материально-технической базы поликлиника являлась одним из самых современных
            амбулаторных лечебно-диагностических учреждений г.Москвы. Поликлиника была оснащена сложными инженерными
            системами и коммуникациями. За годы своего существования поликлиника несколько раз меняла свое название.</p>
        <p style="text-indent: 20px">22 ноября 1991 года приказом № 57 по Управлению делами Совмина СССР поликлиника
            передается в подчинение Финансово-хозяйственному управлению Аппарата Президента СССР.</p>
        <p style="text-indent: 20px">После распада СССР Указом Президента Российской Федерации от 19.11.91 года
            поликлиника передается Объединению детских учреждений, здравниц и гостиничного комплекса Хозяйственного
            управления Администрации Президента РФ.</p>
        <div class="flex">
            <img src="../../assets/images/staticPages/history6.jpg" alt="history6" height="305" width="305"
                 class="right-5px"/>
            <img src="../../assets/images/staticPages/history5.jpg" alt="history5" height="305" width="305"
                 class="right-5px"/>
            <img src="../../assets/images/staticPages/history4.jpg" alt="history4" height="305" width="305"/>
        </div>
        <p style="text-indent: 20px">Распоряжением Президента РФ от 14.01.93 года № 29-Р Хозяйственное управление
            Администрации Президента РФ реорганизуется в Главное социально-производственное управление Президента РФ, а
            поликлиника переименовывается в поликлинику Главного социально-производственного управления Президента
            РФ.</p>
        <p style="text-indent: 20px">Указом Президента РФ от 22.02.93 года № 273 в связи с реорганизацией Главного
            социально-производственного управления Президента РФ поликлиника переименована в поликлинику Главного
            социально-производственного управления Администрации Президента РФ.</p>
        <p style="text-indent: 20px">Распоряжением Президента РФ № 735-Р от 15.11.93 года в связи с реорганизацией
            Главного социально-производственного управления Администрации Президента РФ поликлиника переименована в
            поликлинику Управления делами Президента Российской Федерации, с этого момента начинается новый качественный
            этап в деятельности учреждения.</p>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "history",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex img {
    width: 33%;
    height: auto;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

.right-5px {
    margin-right: 5px;
}

</style>
